import { render, staticRenderFns } from "./DashboCerti.vue?vue&type=template&id=a1dfc866"
import script from "./DashboCerti.js?vue&type=script&lang=js&external"
export * from "./DashboCerti.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports